<template>
    <div id="main-wrapper" class="section">
        <div class="container" role="main">
            <div class="flex-row row column-content-wrapper">
                <div id="content" class="col-12 article-container">
                    <article
                        id="page-117"
                        class="post-117 page type-page status-publish czr-hentry"
                    >
                        <header class="entry-header">
                            <div class="entry-header-inner">
                                <h1 class="entry-title">Developers’ Resources</h1>
                            </div>
                        </header>
                        <div class="post-entry tc-content-inner">
                            <section class="post-content entry-content">
                                <div class="czr-wp-the-content">
                                            You can add a reference to your Wersa code on your website. To help you along we created this resource page.
                                            Use the HTML generator form below to select your design and we will create the HTML for you.
                                            <br/>
                                            <br/>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-12">
                                            <h3><u>HTML generator</u></h3>
                                            <br />
                                            <div class="form">
                                                <div class="form-group row">
                                                    <label
                                                        class="col-sm-5 col-form-label"
                                                    >Your Wersa code:</label>
                                                    <div class="col-sm-7">
                                                        <input type="text" class="form-control" placeholder="Example: C1A-1001" 
                                                        :value="code.toUpperCase()" @input="code = $event.target.value.toUpperCase()"/>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        class="col-sm-5 col-form-label"
                                                    >Add a hyper-link :</label>
                                                    <div class="col-sm-7">
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="link"
                                                                v-model="link"
                                                                value="1"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            >App integration universal-link</label>
                                                        </div>
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="link"
                                                                v-model="link"
                                                                value="2"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            > "What is this?" link</label>
                                                        </div>
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="link"
                                                                v-model="link"
                                                                value="3"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            > "What is this?" link, own line</label>
                                                        </div>
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="link"
                                                                v-model="link"
                                                                value="4"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            >No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="form-group row">
                                                    <label
                                                        class="col-sm-7 col-form-label"
                                                    >Add a "What is this?" link:</label>
                                                    <div class="col-sm-5">
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="whatisthis"
                                                                v-model="whatIsThis"
                                                                value="1"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            >Yes</label>
                                                        </div>
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="whatisthis"
                                                                v-model="whatIsThis"
                                                                value="2"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            >Yes, own line</label>
                                                        </div>
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="whatisthis"
                                                                v-model="whatIsThis"
                                                                value="3"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="gridRadios1"
                                                            >No</label>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <template v-if="haveCode">
                                                <label>HTML code:</label>
                                                <textarea v-text="html" rows="3" readonly></textarea>
                                                <button type="button" class="btn btn-more btn-skin-dark btn-secondary" @click="copy">Copy to clipboard</button>
                                                <br/>
                                            </template>
                                            <br/>
                                        </div>
                                        <div class="col-lg-1 col-md-12"></div>
                                        <div class="col-lg-4 col-md-12">
                                            <h3><u>{{this.haveCode?'Preview':'Example'}}</u></h3>
                                            <br />
                                            <div v-html="html"></div>
                                            
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="row">
                                        <div class="col-lg-7 col-md-12">
                                            <h3><u>API access</u></h3>
                                            <br/>
                                            We also developed a API for integration with your business computer system. Details to be publicised soon.
                                        </div>
                                    </div>
                                </div>
                                <footer class="post-footer clearfix"></footer>
                            </section>
                            <!-- .entry-content -->
                        </div>
                        <!-- .post-entry -->
                    </article>
                </div>
            </div>
            <!-- .column-content-wrapper -->
        </div>
        <!-- .container -->

        <div id="czr-push-footer"></div>
    </div>
    <!-- #main-wrapper -->
</template>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo() {
        return {
            title: "Developers’ Resources | Wersa",
            link: [
                { rel: 'canonical', href: 'https://wersa.co.za/resources' }
            ]
        };
    },
    mounted: function()
    {
    // From testing, without a brief timeout, it won't work.
        this.code = this.$route.hash.replace('#','');
    },
    data () {
        return {
            code: "",
            whatIsThis: 1,
            link: 1
        };
    },
    computed: {
        html : function() {
            let code = (!this.code || this.code.length === 0) ? 'C1A-1001':this.code ;

            return '<strong>Wersa: </strong>' + 
            (this.link==1? ('<a href="https://wersa.co.za/my-code#'+ code +'" target="blank" >'+ code +'<a/>') :code) + 
            (this.link==2? ('&nbsp;<a href="http://wersa.co.za/app" target="blank" >What is this?<a/>'):'') +
            (this.link==3? ('<br/>\n<a href="http://wersa.co.za/app" target="blank" >What is this?<a/>'):'')
            // (this.deepLink==1? ('<a href="https://wersa.co.za/my-code#'+ this.code +'" target="blank" >'+ this.code +'<a/>') :this.code) + 
            // (this.whatIsThis<3? ((this.whatIsThis==2?'<br/>\n':' \n') + '<a href="http://wersa.co.za/app" target="blank" >What is this?<a/>'):'')
        },
        haveCode: function() {
            return !(!this.code || this.code.length === 0);
        }
    },
    methods:{
        copy() {
            navigator.clipboard.writeText(this.html)
                .then(() => {
                    alert("HTML copied");
                })
            .catch(() => {
                //console.error(e);
                this.message = 'Sorry, unable to copy to clipboard.';
            });    
        }
    } 
};
</script>